import React, { Component } from 'react';
import { connect } from 'react-redux';
import { isEqual } from 'lodash';
import Filter from '../../App/Layout/Filter';
import Actions from '../../../Actions';
import API from '../../../Configs';
import { denormalizeData } from '../../../Schemas';

class ListHeader extends Component {
    constructor(props){
        super(props);
        this.priorities = [{id: 0, name: "Normal"},{id: 1, name: "Urgent"}];
        this.HS = [{id: 0, name: "Yes"},{id: 1, name: "No"}];
    }

    loadUsers = () => {
        const { token, userStore, getUsers} = this.props;
        const query = { page:1, sort: 'name', order: 'asc', per_page: 1000};
        if(!isEqual(userStore.query,query)){
            getUsers(token,query,false);
        }
    }

    loadLocations = () => {
        const { token, locationStore, getLocations } = this.props;
        const query = { page:1, sort: 'name', order: 'asc', per_page: 1000};
        if(!isEqual(locationStore.query,query)){
            getLocations(token,query,false);
        }
    }

    loadTypes = () => {
        const { token, typeStore, getTypes } = this.props;
        const query = { page:1, sort: 'name', order: 'asc', per_page: 1000};
        if(!isEqual(typeStore.query,query)){
            getTypes(token,query,false);
        }
    }

    loadCompanies = () => {
        const { token, companyStore, getCompanies } = this.props;
        const query = { page:1, sort: 'name', order: 'asc', per_page: 1000};
        if(!isEqual(companyStore.query,query)){
            getCompanies(token,query,false);
        }
    }

    componentDidMount(){
        const { permissions: { can } } = this.props;
        this.loadLocations();
        this.loadTypes();
        this.loadUsers();
        if(can('post','companies')){
            this.loadCompanies();
        }
    }

    render(){
        const { getJobs, query, userStore, typeStore, locationStore, companyStore, permissions: { can } } = this.props;
        const { locations, locationsMeta: { data : locationIds } } = locationStore;
        const { types, typesMeta: { data : typeIds }} = typeStore;
        const { users, usersMeta: { data : userIds }} = userStore;
        const { companies, companiesMeta: { data : companyIds = [] }} = companyStore;
        return (
            <tr>
                <th className="text-nowrap">
                    <Filter query={query} id="niggle-id" title="Niggle" field="vanity_id" filter={getJobs} />
                </th>
                <th className="text-nowrap">
                    <Filter query={query} id="type" title="Type" field="type_id" filter={getJobs} data={denormalizeData(types, typeIds , "types").types} />
                </th>
                <th className="text-nowrap">
                    <Filter query={query} id="h-s" title="H&S" field="HS" filter={getJobs} data={this.HS} />
                </th>
                <th className="text-nowrap">
                    <Filter query={query} id="age" title="Age" field="created_at" filter={getJobs} />    
                </th>
                <th className="text-nowrap">
                    <Filter query={query} id="location" title="Location" field="location_id" filter={getJobs} data={denormalizeData(locations, locationIds , "locations").locations}  />
                </th>
                <th className="text-nowrap">
                    <Filter query={query} id="status" title="Status" field="status" filter={getJobs} data={API.STATUSES_DENORMALIZED} />
                </th>
                <th className="text-nowrap">
                    <Filter query={query} id="priority" title="Priority" field="priority" filter={getJobs} data={this.priorities} />
                </th>
                <th className="text-nowrap">
                    Image
                </th>
                <th className="text-nowrap">
                    <Filter query={query} id="created_by" title="Created By" field="user_id" filter={getJobs} data={denormalizeData(users, userIds , "users").users} />
                </th>
                <th className="text-nowrap">
                    <Filter query={query} id="assigned_to" title="Assigned To" field="assigned_to" filter={getJobs} data={denormalizeData(users, userIds , "users").users} />
                </th>
                {can('post','companies')? 
                    <th className="text-nowrap">
                        <Filter query={query} id="company_id" title="Company" field="company_id" filter={getJobs} data={denormalizeData(companies, companyIds , "companies").companies} />
                    </th>:null}
                {can('delete','jobs')? <th>Delete</th>:null}
            </tr>
        );
    }
}

const mapStateToProps = (state) => ({
    token: state.auth.token,
    typeStore: state.typeStore,
    locationStore: state.locationStore,
    userStore: state.userStore,
    companyStore: state.companyStore,
    query: state.jobStore.query,
});

const { types, locations, jobs, users, companies } = Actions;

export default connect(mapStateToProps, {...types, ...locations, ...jobs, ...users, ...companies})(ListHeader);


// WEBPACK FOOTER //
// ./src/Components/App/Jobs/ListHeader.js